import React, { useEffect, useState } from 'react';
import { CardBody, Col, Row, Input, Label, Button, Form, FormFeedback, Alert, Spinner, Container } from 'reactstrap';
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "../../components/common/withRouter";
import * as Yup from "yup";
import { useFormik } from "formik";
import { loginUser, resetLoginFlag } from "../../slices/Thunks";
import aimeeLogo from "../../assets/images/AIMEE-LOGO.png";

import { getPermissionsList } from '../../slices/veloxity/auth/permissionsManagement/getPermissionList';
import { createSelector } from 'reselect';

const Login = (props) => {
    const dispatch = useDispatch();

    const loginpageData = createSelector(
        (state) => state,
        (state) => ({
            user: state.Account.user,
            error: state.loginSlice.error,
            loading: state.loginSlice.loading,
            errorMsg: state.loginSlice.errorMsg,
        })
    );

    const { user, error, loading, errorMsg } = useSelector(loginpageData);
    const [userLogin, setUserLogin] = useState([]);
    const [passwordShow, setPasswordShow] = useState(false);

    useEffect(() => {
        if (user) {
            setUserLogin({
                email: user.user.email,
                password: user.user.confirm_password,
            });
        }
    }, [user]);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: userLogin.email || '',
            password: userLogin.password || '',
        },
        validationSchema: Yup.object({
            email: Yup.string().required("Please Enter Your Email"),
            password: Yup.string().required("Please Enter Your Password"),
        }),
        onSubmit: async (values) => {
            try {
                await dispatch(loginUser(values, props.router.navigate));
                await dispatch(getPermissionsList());
            } catch (error) {
                console.error("Error during login or fetching permissions:", error);
            }
        }
    });

    useEffect(() => {
        if (errorMsg) {
            setTimeout(() => {
                dispatch(resetLoginFlag());
            }, 3000);
        }
    }, [dispatch, errorMsg]);

    document.title = "AIMEE - Log in";

    return (
        <React.Fragment>
            <div className="bg-pattern">
                <div className="bg-overlay" style={{ backgroundColor: 'rgba(255, 255, 255, 0.089)' }}></div>
                <Row className="justify-content-center h-100 align-items-center">
                    <Col xl={4} lg={6} md={8}>
                        <Container className="text-center">
                        <CardBody className="login-card mt-5" style={{ backgroundColor: 'rgba(255, 255, 255, 0.4)', borderRadius: '8px' }}>

                                <div className="mb-4">
                                    <img src={aimeeLogo} alt="AIMEE Logo" style={{ maxWidth: '20vh', height: 'auto' }} />
                                </div>
                                <h4 className="text-center mb-4">Welcome Back!</h4>
                                <p className="text-center text-muted">Sign in to continue to AIMEE</p>
                                {errorMsg && error && (
                                    <Alert color="danger">{errorMsg}</Alert>
                                )}
                                <Form onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                    return false;
                                }} className="mb-4 text-start"> {/* Formu sola hizaladık */}
                                    <div className="mb-3">
                                        <Label className="form-label text-start w-100">Email</Label> {/* Label sola hizalı */}
                                        <Input
                                            name="email"
                                            placeholder="Enter email"
                                            type="email"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.email || ""}
                                            style={{ borderRadius: '30px', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' }}
                                            invalid={validation.touched.email && validation.errors.email ? true : false}
                                        />
                                        {validation.touched.email && validation.errors.email && (
                                            <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                        )}
                                    </div>

                                    <div className="mb-3">
                                        <Label className="form-label text-start w-100">Password</Label> {/* Label sola hizalı */}
                                        <Input
                                            name="password"
                                            type={passwordShow ? "text" : "password"}
                                            placeholder="Enter Password"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.password || ""}
                                            style={{ borderRadius: '30px', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' }}
                                            invalid={validation.touched.password && validation.errors.password ? true : false}
                                        />
                                        {validation.touched.password && validation.errors.password && (
                                            <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                                        )}
                                    </div>

                                    <Row className="mb-3">
                                        <Col>
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="customControlInline"
                                                />
                                                <label className="form-check-label" htmlFor="customControlInline">
                                                    Remember me
                                                </label>
                                            </div>
                                        </Col>
                                        <Col className="col-7 text-end"> {/* Link sağa hizalı */}
                                            <Link to="/forgot-password" className="text-muted">
                                                <i className="mdi mdi-lock"></i> Forgot your password?
                                            </Link>
                                        </Col>
                                    </Row>

                                    <Button color="primary" type="submit" block className="w-100 mt-4" disabled={loading} style={{ borderRadius: '30px', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' }}>
                                        {loading ? <Spinner size="sm" className="me-2" /> : null}
                                        Log In
                                    </Button>
                                </Form>
                            </CardBody>
                            <div className="mt-4 text-center text-muted">
                                <p>© 2024 AIMEE. Copyright by Veloxity</p>
                            </div>
                        </Container>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    );
};

export default withRouter(Login);
